import React from 'react';
import { Dialog } from 'primereact/dialog';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

const SalaryHistoryDialog = ({ visible, onHide, employee, history }) => {
  return (
    <Dialog 
      header={`Salary History - ${employee?.firstName} ${employee?.lastName}`} 
      visible={visible} 
      style={{ width: '70vw' }} 
      onHide={onHide}
      maximizable
    >
      <div className="grid grid-cols-2 gap-4 mb-4 p-3 bg-blue-50 rounded-lg">
        <div>
          <p className="text-sm text-gray-600">Employee ID: <span className="font-bold text-gray-900">{employee?.id}</span></p>
          <p className="text-sm text-gray-600">Designation: <span className="font-bold text-gray-900">{employee?.designation}</span></p>
        </div>
        <div>
          <p className="text-sm text-gray-600">Email: <span className="font-bold text-gray-900">{employee?.email}</span></p>
          <p className="text-sm text-gray-600">Base Salary: <span className="font-bold text-gray-900">₹{employee?.salary}</span></p>
        </div>
      </div>

      <DataTable value={history} responsiveLayout="scroll" className="p-datatable-sm" emptyMessage="No salary history found">
        <Column field="salaryMonth" header="Month" body={(rd) => rd.salaryMonth ? new Date(rd.salaryMonth).toLocaleDateString(undefined, { month: 'long', year: 'numeric' }) : '-'} />
        <Column field="basicSalary" header="Basic" body={(rd) => `₹${rd.basicSalary}`} />
        <Column field="allowanceAmount" header="Allowances" body={(rd) => `₹${rd.allowanceAmount}`} />
        <Column field="pfAmount" header="PF Deduction" body={(rd) => `₹${rd.pfAmount}`} />
        <Column field="netSalary" header="Net Salary" body={(rd) => <span className="font-bold text-green-600">₹{rd.netSalary}</span>} />
        <Column field="paymentMode" header="Mode" />
        <Column field="paidAt" header="Paid On" body={(rd) => rd.paidAt ? new Date(rd.paidAt).toLocaleDateString() : '-'} />
      </DataTable>
    </Dialog>
  );
};

export default SalaryHistoryDialog;
